import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { usePostOnboardingDataMutation } from "../../../store/api/onboardingApi";
import { ONBOARDING_PAGE_ID } from "../../../constants";
import { useAppSelector } from "../../../hooks/store-hooks";
import { ONBOARDING_EARN_XP_SCHEMA } from "../../../helpers/validation-schema";
import { ROUTES } from "../../../constants/routes";
import { useEffect } from "react";
import SocialsComp from "../../../components/onboarding/socials";
import AuthLayout from "../../../components/layouts/auth";
import SocialsSuccessComp from "../../../components/onboarding/social-success";
import { useState } from "react";
import { MixpanelEvent, trackEvent } from "../../../analytics/mixpanel";

const Socials = () => {
  const navigate = useNavigate();

  const [postOnboardingData] = usePostOnboardingDataMutation();

  const screenName = ONBOARDING_PAGE_ID.USER_SOCIALS;

  const { data: onboardingData }: any = useAppSelector(
    (state) => state.onboarding || {},
  );

  const [showSuccess, setShowSuccess] = useState(false);

  const methods = useForm<any>({
    mode: "onSubmit",
    reValidateMode: "onChange",
    resolver: yupResolver(ONBOARDING_EARN_XP_SCHEMA),
    defaultValues: {
      linkedin: "",
    },
  });

  const { handleSubmit, setValue } = methods;

  const onSubmit = async (data: any) => {
    if (showSuccess) {
      navigate(ROUTES.HOME);
      return;
    }
    const response = await postOnboardingData({
      page_id: ONBOARDING_PAGE_ID.USER_SOCIALS,
      socials: { ...data },
    });
    const linkedinUrl = data.linkedin ? data.linkedin.trim() : "";
    if (response?.data?.success && linkedinUrl === "") {
      trackEvent(MixpanelEvent.ONBOARDING_LINKEDIN_SKIP, {});
      navigate(ROUTES.HOME);
      return;
    }
    if (response?.data?.success) {
      trackEvent(MixpanelEvent.ONBOARDING_LINKEDIN_SUBMIT, {});
      setShowSuccess(true);
    }
  };

  useEffect(() => {
    if (onboardingData?.page_id === screenName) {
      const pageData = onboardingData?.page_data || [];
      pageData.forEach((itm: any) => {
        const value = Object.values(itm?.value)?.[0];
        setValue(`linkedin`, value);
      });
    }
  }, [onboardingData]);

  return (
    <FormProvider {...methods}>
      <AuthLayout screenName={screenName}>
        <form className="flex w-full h-full" onSubmit={handleSubmit(onSubmit)}>
          {showSuccess ? <SocialsSuccessComp /> : <SocialsComp />}
        </form>
      </AuthLayout>
    </FormProvider>
  );
};

export default Socials;
